import React from "react";
import Logo from "../assets/logo.png"

function Navbar() {      
    return (
      <nav className="navbar">
        <div className="container">
          <div className="logo-img">
                <img className="header-logo" src={Logo} alt="Merchant-logo" width="200px" height={"200px"}/>
          </div> 
          <div className="nav-elements">
            <ul>
              <li>About</li>
              <li>Contact</li>
              <button className="button"><span style={{ fontWeight: "700", fontSize: "16px" }}>Download</span></button>
            </ul>
          </div>
        </div>
      </nav>
    

  
  
    );
  };
  
  
  

export default Navbar